<img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>

<mat-card class="simple-card mx-auto mb-5">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between">
                <h1>Tesoreria</h1>
                <button mat-button class="custom-button-primary no-print" [matMenuTriggerFor]="descarga" (click)="expandAllView()">
                    <span class="d-flex align-items-center justify-content-between w-100">
                        <span class="d-flex align-items-center">
                            <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download mr-2"></mat-icon>
                            <span>Descargar Resultado</span>
                        </span>
                        <mat-icon aria-hidden="false" aria-label="Icono de descarga seleccion" fontIcon="arrow_right" class="icon-download ml-3"></mat-icon>
                    </span>
                </button>
                <mat-menu #descarga="matMenu">
                    <button 
                        mat-menu-item
                        [printTitle]='"Tesoreria_"+(rut ? (rut | rutFormat) : "")+"_"+today'
                        [useExistingCss]="true"
                        printSectionId="print-section"
                        (mouseenter)="isResumida = false"
                        (click)="isResumida = false"
                        ngxPrint
                    >Vista Completa
                    </button>
                    <button 
                        mat-menu-item
                        [printTitle]='"Tesoreria_"+(rut ? (rut | rutFormat) : "")+"_"+today'
                        [useExistingCss]="true"
                        printSectionId="print-section"
                        (mouseenter)="isResumida = true"
                        (click)="isResumida = true"
                        ngxPrint
                    >Vista Resumida
                    </button>
                </mat-menu>
            </div>

            <div class="col-12 my-3" *ngIf="rut">
                <mat-chip-set aria-label="Rut - tipo reporte">
                    <mat-chip class="chip-rut"><strong>RUT:</strong> {{rut | rutFormat | uppercase}} </mat-chip>
                    <mat-chip class="chip-rut" *ngIf="getTipoCartola()">Reporte {{getTipoCartola()}} </mat-chip>
                </mat-chip-set>
            </div>

            <ng-container *ngFor="let reporte of objReportes">
                <!--<ng-container *ngIf="(validateTypeArray(reporte.data) && reporte.data.length > 0) || (reporte.data && objKeys(reporte.data).length > 0)">-->
                    <div class="col-12 mx-auto mb-3" [ngClass]="{'no-print': isResumida && noShowResumido.includes(reporte.key)}">
                        <div class="row break-box">
                            <div class="col-sm-12 mb-2 mx-auto">
                                <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                                <strong>{{reporte.title || ''}}</strong>
                            </div>
                            <div class="col-sm-12 mx-auto mb-5">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="getDataSource(reporte.data)" multiTemplateDataRows>
                                    <!--<table mat-table [dataSource]="validateTypeArray(reporte.data) ? reporte.data : [reporte.data]" multiTemplateDataRows>-->
                                        <!--cabecera extra-->
                                        <ng-container *ngIf="reporte.headerGroups && reporte.headerGroups.length > 0">
                                            <ng-container *ngFor="let headerGroup of reporte.headerGroups; let i = index">
                                                <ng-container [matColumnDef]="toString(i)">
                                                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="headerGroup.colspan"> {{headerGroup.label}} </th>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                        <!--tabla con cabecera base-->
                                        <ng-container *ngFor="let header of reporte.headers" [matColumnDef]="header.key">
                                            <th mat-header-cell *matHeaderCellDef> {{header.value}} </th>
                                            <td mat-cell *matCellDef="let element" 
                                                (click)="reporte.expandable ? toggleExpand(reporte.key, element) : null" 
                                                [ngClass]="{'cursor-pointer': reporte.expandable, 'bg-primary-selected': reporte.expandable && isExpanded(reporte.key, element)}"
                                            >
                                                <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: {key: header.key, value: element[header.key]} }"></ng-container>
                                                
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="expandedDetail" *ngIf="reporte.expandable">
                                            <td mat-cell *matCellDef="let element" [attr.colspan]="reporte.displayedColumns.length">
                                                <div *ngIf="isExpanded(reporte.key, element)">
                                                    <ng-container *ngIf="reporte.expandable == 'simple'">
                                                        <ng-container *ngTemplateOutlet="simpleExpandable; context: { $implicit: {expandableData: reporte.expandableData, data: element?.detalle} }"></ng-container>
                                                    </ng-container>
                                                    <ng-container *ngIf="reporte.expandable == 'convenio'">
                                                        <ng-container *ngTemplateOutlet="convenioExpandable; context: { $implicit: {expandableData: reporte.expandableData, datos: element?.datos, deudas: element?.datos?.deudas, cuotas: element?.datos?.cuotas} }"></ng-container>
                                                    </ng-container>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <!--definicion de cabecera extra-->
                                        <ng-container *ngIf="reporte.headerGroups && reporte.headerGroups.length > 0">
                                            <tr mat-header-row *matHeaderRowDef="getArrayGroups(reporte.headerGroups)"></tr>
                                        </ng-container>
                                        <!--definicion de tabla con cabecera base-->
                                        <tr mat-header-row *matHeaderRowDef="reporte.displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: reporte.displayedColumns;"></tr>
                                        <ng-container *ngIf="reporte.expandable">
                                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"
                                                [class.example-expanded-row]="isExpanded(reporte.key, row)" 
                                                [hidden]="!isExpanded(reporte.key, row)"
                                            >
                                            </tr>
                                        </ng-container>

                                        <tr class="mat-row text-center" *matNoDataRow>
                                            <td class="mat-cell p-3 text-muted" [attr.colspan]="reporte.displayedColumns.length">
                                                Sin información disponible
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                <!--</ng-container>-->
            </ng-container>

            <div class="col-12 my-3 mt-5 no-print" *ngIf="errores.length > 0">
                <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel togglePosition="before">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <strong>Detalle Errores</strong>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="row">
                            <div class="col-12" *ngFor="let item of errores">
                                <mat-card class="error-container">
                                    <mat-card-content>
                                        <div class="text-error-color fw-bold"><b>{{ item.title || '' }}</b></div>
                                        <div class="text-muted">{{ item.message || '' }}</div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <div class="col-12 my-3 mt-5 no-print" *ngIf="getTipoCartola() === 'sin cartola'">
                <mat-card class="shadow-none" style="background-color: #FFF3CD; border-left: 4px solid #FFC107; border-radius: 4px; width: fit-content !important;">
                    <mat-card-content class="d-flex align-items-center py-2 px-3">
                        <span style="color: #856404; font-size: 14px;">
                            <strong>Nota:</strong> No se disponen de datos de la cartola, por lo que se presentan mas secciones sin información disponible.
                        </span>
                    </mat-card-content>
                </mat-card>
            </div>
            
        </div>
    </mat-card-content>
</mat-card>


<ng-template #simpleExpandable let-elemento>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive border">
                <table mat-table [dataSource]="elemento.data" multiTemplateDataRows>
                    <!-- Definición de columnas -->
                    <ng-container *ngFor="let header of elemento.expandableData.header" [matColumnDef]="header.key">
                        <th mat-header-cell *matHeaderCellDef> {{header.value}} </th>
                        <td mat-cell *matCellDef="let row">
                            <span *ngIf="row && (row[header.key] || row[header.key] === 0)">
                                <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: {key: header.key, value: row[header.key]} }"></ng-container>
                            </span>
                        </td>
                    </ng-container>
                
                    <!-- Fila de encabezado -->
                    <tr mat-header-row *matHeaderRowDef="elemento.expandableData.displayedColumns"></tr>
                    <!-- Filas de datos -->
                    <tr mat-row *matRowDef="let row; columns: elemento.expandableData.displayedColumns;"></tr>

                    <tr class="mat-row text-center" *matNoDataRow>
                        <td class="mat-cell p-3 text-muted" [attr.colspan]="elemento.expandableData.displayedColumns.length">
                            Sin información disponible
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #convenioExpandable let-elemento>
    <div class="row">
        <!-- DATOS DEL CONVENIO -->
        <div class="col-12">
            <div class="table-responsive border mb-3">
                <table mat-table [dataSource]="elemento.datos ? [elemento.datos] : []">
                    <ng-container *ngFor="let header of elemento.expandableData.headerDatos" [matColumnDef]="header.key">
                        <th mat-header-cell *matHeaderCellDef> {{header.value}} </th>
                        <td mat-cell *matCellDef="let row">
                            <span *ngIf="row && (row[header.key] || row[header.key] === 0)">
                                <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: {key: header.key, value: row[header.key]} }"></ng-container>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="elemento.expandableData.displayedColumnsDatos"></tr>
                    <tr mat-row *matRowDef="let row; columns: elemento.expandableData.displayedColumnsDatos;"></tr>
                    <tr class="mat-row text-center" *matNoDataRow>
                        <td class="mat-cell p-3 text-muted" [attr.colspan]="elemento.expandableData.displayedColumnsDatos.length">
                            Sin información disponible
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <!-- DEUDAS DEL CONVENIO -->
        <div class="col-12">
            <h5>Deudas</h5>
            <div class="table-responsive border mb-3">
                <table mat-table [dataSource]="elemento.deudas">
                    <ng-container *ngFor="let header of elemento.expandableData.headerDeudas" [matColumnDef]="header.key">
                        <th mat-header-cell *matHeaderCellDef> {{header.value}} </th>
                        <td mat-cell *matCellDef="let row">
                            <span *ngIf="row && (row[header.key] || row[header.key] === 0)">
                                <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: {key: header.key, value: row[header.key]} }"></ng-container>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="elemento.expandableData.displayedColumnsDeudas"></tr>
                    <tr mat-row *matRowDef="let row; columns: elemento.expandableData.displayedColumnsDeudas;"></tr>
                    <tr class="mat-row text-center" *matNoDataRow>
                        <td class="mat-cell p-3 text-muted" [attr.colspan]="elemento.expandableData.displayedColumnsDeudas.length">
                            Sin información disponible
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <!-- BOTÓN VER/CERRAR CUOTAS -->
        <div class="col-12 mb-2">
            <button *ngIf="elemento?.datos?.seeCuotas == false" type="button" class="btn btn-link no-print" (click)="elemento.datos.seeCuotas = true">Ver Cuotas</button>
            <button *ngIf="elemento?.datos?.seeCuotas == true" type="button" class="btn btn-link no-print" (click)="elemento.datos.seeCuotas = false">Cerrar Cuotas</button>
        </div>

        <!-- CUOTAS DEL CONVENIO -->
        <div class="col-12 px-5 mx-auto" *ngIf="elemento?.datos?.seeCuotas == true">
            <h5>Cuotas</h5>
            <div class="table-responsive border">
                <table mat-table [dataSource]="elemento.cuotas">
                    <ng-container *ngFor="let header of elemento.expandableData.headerCuotas" [matColumnDef]="header.key">
                        <th mat-header-cell *matHeaderCellDef> {{header.value}} </th>
                        <td mat-cell *matCellDef="let row">
                            <span *ngIf="row && (row[header.key] || row[header.key] === 0)">
                                <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: {key: header.key, value: row[header.key]} }"></ng-container>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="elemento.expandableData.displayedColumnsCuotas"></tr>
                    <tr mat-row *matRowDef="let row; columns: elemento.expandableData.displayedColumnsCuotas;"></tr>
                    <tr class="mat-row text-center" *matNoDataRow>
                        <td class="mat-cell p-3 text-muted" [attr.colspan]="elemento.expandableData.displayedColumnsCuotas.length">
                            Sin información disponible
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #valueTemplate let-elemento>
    {{
        camposEnteros.includes(elemento.key) ? (elemento.value | number: '1.0-0') :
        (camposFechas.includes(elemento.key) ? (elemento.value | date: 'dd-MM-yyyy') :
        elemento.value)
    }}
</ng-template>